import React from "react";
import PolicyPage from "@/components/PolicyPage";

export default function KullanimSartlari() {
  return (
    <PolicyPage
      slug="kullanim-sartlari"
      title="Kullanım Şartları"
      intro="Abonelik İptal'i kullanmadan önce lütfen aşağıdaki koşulları dikkatlice okuyun. Abonelik İptal'i kullanmanız bu şartları kabul ettiğiniz anlamına gelir."
      metaTitle="Kullanım Şartları | Abonelik İptal"
      metaDescription="Abonelik İptal kullanıcı sözleşmesi, hizmet sınırları ve sorumluluk kapsamına dair açıklamalar."
      sections={[
        {
          heading: "Hizmetin niteliği",
          body: [
            "Abonelik İptal, tüketicilere iptal, iade, fatura itirazı ve Tüketici Hakem Heyeti hazırlıklarında yardımcı olmak için kart tabanlı bir işlem asistanı sunar. Hazırlanan çıktılar taslak niteliğindedir ve göndermeden önce kullanıcı tarafından kontrol edilmelidir.",
          ],
        },
        {
          heading: "Abonelik İptal'in yapmadıkları",
          bullets: [
            "Abonelik İptal resmi bir kurum değildir.",
            "Abonelik İptal hukuki danışmanlık vermez.",
            "Abonelik İptal, kullanıcı adına kuruma resmi başvuru yapmaz — metinleri kullanıcı iletir.",
            "Abonelik İptal, e-Devlet, banka veya kart sistemlerine bağlanmaz ve şifre bilgilerini istemez.",
            "Abonelik İptal, olası bir tüketici uyuşmazlığında kesin başarı garantisi vermez.",
          ],
        },
        {
          heading: "Kullanıcı sorumluluğu",
          bullets: [
            "Girdiğiniz bilgilerin doğruluğundan yalnızca siz sorumlusunuz.",
            "Hazırlanan metnin ilgili kuruma iletilmeden önce içeriğini gözden geçirmek kullanıcının sorumluluğundadır.",
            "Abonelik İptal'i yalnızca bireysel tüketici işlem hazırlığı amacıyla kullanabilirsiniz; kötüye kullanım, otomatik sorgulama veya sahtecilik yasaktır.",
          ],
        },
        {
          heading: "Fikri mülkiyet",
          body: [
            "Abonelik İptal markası, wordmark'ı ve site içeriği Abonelik İptal'e aittir. İzinsiz çoğaltma, kopyalama veya ticari kullanım yasaktır. Abonelik İptal ile oluşturduğunuz kişisel dilekçe metnini kendi başvurunuzda özgürce kullanabilirsiniz.",
          ],
        },
        {
          heading: "Sorumluluğun sınırı",
          body: [
            "Abonelik İptal, sunulan bilgilerin tüketici mevzuatına uygunluğu için makul özeni gösterir; ancak mevzuatın ve kurum politikalarının değişebileceği gerçeği ışığında sonuçların ve kararın sorumluluğu kullanıcıya aittir. Abonelik İptal, dolaylı, arızi veya sonuç niteliğindeki zararlardan sorumlu tutulamaz.",
          ],
        },
        {
          heading: "Değişiklikler",
          body: [
            "Abonelik İptal, bu kullanım şartlarını gerektiğinde güncelleyebilir. Güncel sürüm bu sayfada yayınlanır ve yürürlüğe girer.",
          ],
        },
        {
          heading: "İletişim",
          body: [
            "Kullanım şartlarına ilişkin sorularınız için destek@abonelikiptal.com adresine e-posta gönderebilirsiniz.",
          ],
        },
      ]}
    />
  );
}
